import LocalSettingsProto from "../../gd/settings/local-settings/local-settings-v4";

// const debug = 'NavigationLocalSettings'
const debug = false

export default class NavigationLocalSettings extends LocalSettingsProto {

    public _sectionsLatestAppUrl         : any

    constructor() {
        super(gd.companyId+"."+'navigation')   // ! yes each company has their own settings

        const lsValues          = this._readFromLocalStorage();

        this._sectionsLatestAppUrl        = _.get(lsValues, '_sectionsLatestAppUrl', {})

        //patch
        if (this._sectionsLatestAppUrl['tools'] === 'o/analytics') {
            delete this._sectionsLatestAppUrl['tools']
        }
    }

    getSectionLatestAppUrl(sectionId:string, defaultAppUrl?:string):string|undefined {
        debug && console.log(debug, 'getSectionLatestAppUrl', sectionId, defaultAppUrl, this._sectionsLatestAppUrl)

        return _.get(this._sectionsLatestAppUrl, sectionId, defaultAppUrl)
    }

    setSectionLatestAppUrl(sectionId:string, url:string|undefined) {
        debug && console.log(debug, 'setSectionLatestAppUrl', sectionId, url)

        if (url) {
            this._sectionsLatestAppUrl[sectionId] = url
        } else {
            delete this._sectionsLatestAppUrl[sectionId]
        }
        this.save()
    }

    toObject() {
        return {
            _sectionsLatestAppUrl       : this._sectionsLatestAppUrl
        }
    }
}
